// extracted by mini-css-extract-plugin
export default {"wrapper":"iViyA","container":"oJhnE","label":"YqRu6","checkbox":"nxqBx","error-message":"s4MgI","errorMessage":"s4MgI","error":"fi82O"};